(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[704],{

/***/ 6817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/customer-benefit",
      function () {
        return __webpack_require__(3234);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42031);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var DepositPolicyPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "Chính sách QUYỀN LỢI KH\xc1CH H\xc0NG 72H",
                description: "Chính sách QUYỀN LỢI KH\xc1CH H\xc0NG 72H"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-px-0 lg:tw-px-10 tw-text-base tw-leading-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase",
                            children: "Chính sách QUYỀN LỢI KH\xc1CH H\xc0NG 72H"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "tw-mt-5 tw-flex tw-flex-col tw-gap-y-3 ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "- \xc1p dụng kể từ khi thanh to\xe1n đủ v\xe0 nhận sản phẩm."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: "- Thực hiện thu đổi 72H theo khung giờ l\xe0m việc của hệ thống kim cương An Thư."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-items-center tw-justify-center tw-mt-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "tw-border-t tw-border-r tw-border-l tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ",
                                                children: "Đổi sản phẩm mới c\xf3 gi\xe1 trị cao hơn hoặc ngang bằng sản phẩm cũ"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-r tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center",
                                                children: "-5%"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "tw-border tw-block tw-w-[200px] md:tw-w-[348px] tw-p-[10px] tw-bg-secondary-70/[0.06] tw-text-primary-main tw-font-semibold ",
                                                children: "Đổi sản phẩm mới c\xf3 gi\xe1 trị thấp hơn hoặc An Thư thu lại sản phẩm"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "tw-w-[200px] md:tw-w-[348px] tw-border-t tw-border-b tw-border-r tw-p-[10px] tw-flex tw-items-center tw-justify-center tw-text-center",
                                                children: "-10%"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (DepositPolicyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);